import React from 'react';
import { Routes, Route } from 'react-router-dom';
import variconLogo from 'assets/img/login-logo.png';
import { Stack, ThemeProvider } from 'components/base';
import { baseTheme } from 'theme/base';
import {
  AddResponse,
  EnterCode,
  GuestUserDetail,
  InfoCollection,
  ResponseReceived,
  VariconEmployeeDetail,
  VariconUserDetail,
  VerifyFormLink,
  VerifyIdentity,
} from './containers';
import CustomFormProvider from 'pages/Forms/context/provider';
import FormResultsProvider from 'pages/Forms/FormResults/context/provider';

const QRLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ThemeProvider theme={baseTheme}>
    <Stack
      height="100vh"
      justifyContent="center"
      alignItems="center"
      spacing={3}
      bgcolor="background.default"
    >
      <img src={variconLogo} alt="varicon-logo" />
      {children}
    </Stack>
  </ThemeProvider>
);

const QRScreens: React.FC = () => (
  <Routes>
    {[
      { path: '/', Component: VerifyFormLink, index: true },
      { path: 'verify-identity', Component: VerifyIdentity },
      { path: 'verify-code', Component: EnterCode },
      { path: 'info-collection', Component: InfoCollection },
      { path: 'guest-user-detail', Component: GuestUserDetail },
      { path: 'varicon-user-detail', Component: VariconUserDetail },
      { path: 'varicon-employee-detail', Component: VariconEmployeeDetail },
      { path: 'response-received', Component: ResponseReceived },
    ].map(({ path, Component, index }) => (
      <Route
        key={path}
        {...(index ? { index: true } : { path })}
        element={
          <QRLayout>
            <Component />
          </QRLayout>
        }
      />
    ))}
    <Route
      path="add-response/:id"
      element={
        <QRLayout>
          <CustomFormProvider>
            <FormResultsProvider>
              <AddResponse />
            </FormResultsProvider>
          </CustomFormProvider>
        </QRLayout>
      }
    />
  </Routes>
);

export default QRScreens;
